import i18n from 'modules/core/lib/i18n'

import { LaunchBanner as FinancialWorkspaceLaunchBanner } from 'modules/finance/components/FinancialWorkspace/components/LaunchBanner'
import { useFinancialWorkspaceAvailabilities } from 'modules/finance/components/FinancialWorkspace/hooks/useFinancialWorkspaceAvailabilities'
import { useVisitFWRoutes } from 'modules/finance/components/FinancialWorkspace/hooks/useVisitFW'
import { useSeePayrollLanding } from 'modules/finance/components/FinancialWorkspacePayroll/hooks/useSeePayrollLanding'

import { translations } from './translations'

export const FinancialWorkspaceBanner = () => {
  const {
    modules: { expenses },
    loading: loadingAvailabilities,
  } = useFinancialWorkspaceAvailabilities()
  const { seePayrollLanding: missingPayrollInLastYear, loading: loadingPayroll } =
    useSeePayrollLanding()
  const { financialWorkspaceRoute } = useVisitFWRoutes({ source: 'payroll-bundle' })
  const missingExpensesModule = !expenses

  if (loadingAvailabilities || loadingPayroll) {
    return null
  }

  const translationToShow = () => {
    const payrollKey = missingPayrollInLastYear ? 'noPayroll' : 'payroll'
    const expensesKey = missingExpensesModule ? 'noExpenses' : 'expenses'

    return translations()[payrollKey][expensesKey]
  }

  return (
    <FinancialWorkspaceLaunchBanner
      title={translationToShow().title}
      description={translationToShow().description}
      buttonsConfig={{
        expenses: {
          visible: missingExpensesModule,
        },
        payroll: {
          visible: false,
        },
      }}
      link={{
        src: financialWorkspaceRoute,
        title: i18n.t('finance.financial_workspace.launch_banner.payroll_bundle.link'),
      }}
      localStorageKey={'financialWorkspacePayrollBundleBanner'}
      source={'payroll-bundle'}
      requestComponent="Payroll Bundle FW banner"
      modulesAvailability={{
        expenses: !missingExpensesModule,
        payroll: !missingPayrollInLastYear,
      }}
    />
  )
}
